import { equals2 } from "fxjs/es";
import { CommonNS } from "../../../../Common/CommonNS.js";
import { ControllerNS } from "../../Controller/ControllerNS.js";
import { VONS } from "../../VO/VONS.js";
export class RubberBandView {
  constructor({ rubber_band_el, rubber_band_controller }) {
    this._rubber_band_el = rubber_band_el;
    rubber_band_controller.subscribe((vo) =>
      this._observeRubberBandController(vo)
    );
  }
  _observeRubberBandController({ status, point1, point2 }) {
    if (equals2(status)("PENDING")) {
      this._rubber_band_el.style.display = "none";
    } else {
      this._rubber_band_el.style.display = "";
    }
    const { min_x, min_y, max_x, max_y } = CommonNS.UtilNS.calculateMinMaxXY([
      point1,
      point2,
    ]);
    const d = `M ${min_x} ${min_y} L ${max_x} ${min_y} L ${max_x} ${max_y} L ${min_x} ${max_y} Z`;
    this._rubber_band_el.setAttributeNS(null, "d", d);
  }
}
